import axios from '@/utils/request'
//我的报名
export function sign(data) {
    return axios({
        url: '/my/sign',
        method: 'get',
        params: data
    })
}
//报名详情
export function signDetail(id) {
    return axios({
        url: '/my/sign/' + id,
        method: 'get',
    })
}